// SelectedViewContext.js
import { createContext, useState, useContext } from "react";

const SelectedViewContext = createContext();

export const SelectedViewProvider = ({ children }) => {
  const [selectedView, setSelectedView] = useState("");

  return (
    <SelectedViewContext.Provider value={{ selectedView, setSelectedView }}>
      {children}
    </SelectedViewContext.Provider>
  );
};

// Custom hook for convenience
export const useSelectedView = () => useContext(SelectedViewContext);
